export const ACCOUNT_TYPES = {
  AGENCY: 'agency',
  ADVERTISER: 'advertiser',
} as const;
export type ACCOUNT_TYPES = (typeof ACCOUNT_TYPES)[keyof typeof ACCOUNT_TYPES];
